// 服务模块「无既有页面」条目的通用子页配置（SvcPage 按 meta 渲染表单/查询/列表）
// mode: form=表单提交（默认字段：姓名+证件号码）；query=查询展示（默认字段：证件号码）；list=直接展示
// fields: 自定义字段；rows: 查询/列表演示数据；success: 提交成功文案；tip: 底部说明
export default [
  // ===== 就业创业 =====
  { path: '/policy-query', title: '个人就业创业扶持政策享受情况查询', mode: 'query', rows: [
    { '政策项目': '富民创业担保贷款贴息', '享受年度': '2025', '补贴金额（元）': '5400.00', '发放状态': '已发放' },
    { '政策项目': '灵活就业人员社会保险补贴', '享受年度': '2024', '补贴金额（元）': '7200.00', '发放状态': '已发放' }
  ] },
  // ===== 社会保险 · 企业职工基本养老保险 =====
  { path: '/flexible-registration', title: '灵活就业人员就业和社会保险登记', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '手机号码', type: 'tel', maxlength: 11 }, { label: '参保地', placeholder: '如：南京市江北新区' }
  ], success: '登记申请已提交，请等待审核' },
  { path: '/flexible-deregistration', title: '灵活就业人员停保登记', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '停保年月', placeholder: '如：202610' }
  ], success: '停保登记申请已提交' },
  { path: '/retiree-exam-booking', title: '企业退休人员体检预约', mode: 'form', fields: [
    { label: '姓名' }, { label: '体检医院', placeholder: '如：南京市第一医院' }, { label: '预约日期', placeholder: '如：2026-10-15' }
  ], success: '体检预约成功，请按时前往' },
  { path: '/pension-insured-query', title: '参保信息查询', mode: 'query', rows: [
    { '险种': '企业职工基本养老保险', '参保状态': '参保缴费', '参保单位': '江苏超芯星半导体有限公司', '首次参保日期': '2016-10-12' }
  ] },
  { path: '/pension-change-query', title: '参保变更信息查询', mode: 'query', rows: [
    { '变更项目': '单位名称变更', '变更前': '中锗科技有限公司', '变更后': '江苏超芯星半导体有限公司', '变更日期': '2020-07-06' }
  ] },
  { path: '/pension-payment-query', title: '缴费记录查询', mode: 'query', rows: [
    { '缴费年月': '2026-09', '缴费基数（元）': '4952.00', '个人缴费（元）': '396.16', '到账状态': '已到账' },
    { '缴费年月': '2026-08', '缴费基数（元）': '4952.00', '个人缴费（元）': '396.16', '到账状态': '已到账' },
    { '缴费年月': '2026-07', '缴费基数（元）': '4952.00', '个人缴费（元）': '396.16', '到账状态': '已到账' }
  ] },
  { path: '/retiree-info-query', title: '企业离退休信息查询', mode: 'query' },
  { path: '/pension-benefit-query', title: '养老待遇发放查询', mode: 'query', rows: [
    { '发放月份': '2026-09', '应发金额（元）': '3268.50', '实发金额（元）': '3268.50', '发放状态': '已发放' },
    { '发放月份': '2026-08', '应发金额（元）': '3268.50', '实发金额（元）': '3268.50', '发放状态': '已发放' }
  ] },
  { path: '/transition-pension-query', title: '过渡性养老金调整情况查询', mode: 'query' },
  { path: '/pension-adjust-query', title: '养老金调整情况查询', mode: 'query', rows: [
    { '调整年度': '2026', '调整方式': '定额+挂钩+倾斜', '月增发（元）': '86.00', '补发金额（元）': '516.00' }
  ] },

  // ===== 社会保险 · 机关事业单位养老保险 =====
  { path: '/gov-pension-payment-query', title: '机关事业单位养老保险缴费记录查询', mode: 'query' },
  { path: '/gov-pension-payment-cert', title: '机关事业单位养老保险缴费证明', mode: 'form', fields: [
    { label: '证件号码', maxlength: 18 }, { label: '证明用途', placeholder: '如：购房、落户' }, { label: '起始年月', placeholder: '如：202001' }, { label: '截止年月', placeholder: '如：202609' }
  ], success: '缴费证明已生成，请保存或打印' },
  { path: '/gov-pension-benefit-query', title: '机关事业单位养老保险待遇发放查询', mode: 'query' },
  { path: '/gov-pension-benefit-cert', title: '机关事业单位养老保险待遇领取证明', mode: 'form', fields: [
    { label: '证件号码', maxlength: 18 }, { label: '证明用途', placeholder: '如：资格核验' }
  ], success: '待遇领取证明已生成' },
  { path: '/gov-pension-adjust-query', title: '机关事业单位年度调待明细查询', mode: 'query' },
  { path: '/occupational-annuity-payment-query', title: '职业年金个人缴费情况查询', mode: 'query', rows: [
    { '缴费年度': '2025', '个人缴费（元）': '2400.00', '单位缴费（元）': '9600.00', '计息状态': '已计息' },
    { '缴费年度': '2024', '个人缴费（元）': '2280.00', '单位缴费（元）': '9120.00', '计息状态': '已计息' }
  ] },
  { path: '/occupational-annuity-result-query', title: '职业年金待遇核定结果查询', mode: 'query' },
  { path: '/occupational-annuity-progress-query', title: '职业年金待遇核定进度查询', mode: 'query', rows: [
    { '受理编号': 'ZJ20260901003', '当前环节': '核定完成', '办理时间': '2026-09-20', '办理状态': '已完成' }
  ] },
  { path: '/occupational-annuity-plan-query', title: '职业年金支付计划查询', mode: 'query' },

  // ===== 社会保险 · 工伤保险 =====
  { path: '/injury-insured-query', title: '工伤保险参保信息查询', mode: 'query', rows: [
    { '险种': '工伤保险', '参保状态': '参保缴费', '参保单位': '江苏超芯星半导体有限公司', '参保日期': '2020-07-06' }
  ] },
  { path: '/injury-change-query', title: '工伤保险参保变更信息查询', mode: 'query' },
  { path: '/injury-payment-query', title: '工伤保险缴费记录查询', mode: 'query' },
  { path: '/injury-base-info', title: '工伤基本信息', mode: 'query', rows: [
    { '认定决定书编号': '苏工认〔2024〕0356号', '伤害部位': '右手手指', '认定日期': '2024-05-18', '鉴定等级': '伤残十级' }
  ] },
  { path: '/injury-support-query', title: '供养基本情况查询', mode: 'query' },
  { path: '/injury-benefit-query', title: '工伤待遇支付明细查询', mode: 'query', rows: [
    { '待遇项目': '一次性伤残补助金', '金额（元）': '46570.00', '支付日期': '2024-07-02', '支付状态': '已支付' },
    { '待遇项目': '劳动能力鉴定费', '金额（元）': '280.00', '支付日期': '2024-06-20', '支付状态': '已支付' }
  ] },
  { path: '/injury-relative-benefit', title: '工伤供养亲属待遇信息', mode: 'query' },
  { path: '/injury-remote-apply', title: '工伤异地居住（就医）申请', mode: 'form', fields: [
    { label: '姓名' }, { label: '异地居住地', placeholder: '如：上海市浦东新区' }, { label: '就医医院', placeholder: '如：上海市第六人民医院' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '异地就医申请已提交' },
  { path: '/injury-medical-grant', title: '一次性工伤医疗补助金申领', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '解除合同日期', placeholder: '如：2026-09-30' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '补助金申领已提交' },
  { path: '/injury-disability-apply', title: '伤残待遇申领（一次性伤残补助金、伤残津贴）', mode: 'form', fields: [
    { label: '姓名' }, { label: '伤残等级', placeholder: '如：伤残十级' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '伤残待遇申领已提交' },

  // ===== 社会保险 · 城乡居民服务 =====
  { path: '/resident-form-print', title: '城乡居民养老保险线上业务表格打印', mode: 'list', rows: [
    { '表格名称': '城乡居民基本养老保险参保登记表' },
    { '表格名称': '城乡居民基本养老保险费补缴申请表' },
    { '表格名称': '城乡居民养老保险待遇核定表' },
    { '表格名称': '城乡居民养老保险关系注销登记表' }
  ] },
  { path: '/resident-supplement-pay', title: '城乡居民基本养老保险费补缴', mode: 'form', fields: [
    { label: '姓名' }, { label: '补缴年度', placeholder: '如：2024' }, { label: '补缴档次', placeholder: '如：1000元/年' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '补缴申请已提交，请按提示完成缴费' },
  { path: '/resident-pause-pay', title: '城乡居民养老保险暂停缴费', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '暂停原因', placeholder: '如：外出务工业主变更' }
  ], success: '暂停缴费申请已提交' },
  { path: '/resident-insured-query', title: '城乡居民参保信息查询', mode: 'query', rows: [
    { '险种': '城乡居民基本养老保险', '参保状态': '正常缴费', '缴费档次': '1000元/年', '参保日期': '2018-03-15' }
  ] },
  { path: '/resident-benefit-check', title: '城乡居民养老保险待遇核定', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '拟领取年龄', placeholder: '如：60' }
  ], success: '待遇核定申请已提交' },
  { path: '/resident-standard-query', title: '城乡居民待遇标准信息查询', mode: 'query', rows: [
    { '缴费档次': '1000元/年', '政府补贴（元）': '60', '基础养老金（元/月）': '208' },
    { '缴费档次': '2000元/年', '政府补贴（元）': '90', '基础养老金（元/月）': '208' }
  ] },
  { path: '/resident-grant-query', title: '城乡居民待遇人员发放信息查询', mode: 'query' },
  { path: '/resident-registration', title: '城乡居民基本养老保险参保登记', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '户籍地址' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '参保登记申请已提交' },
  { path: '/resident-payment-query', title: '城乡居民缴费记录查询', mode: 'query' },

  // ===== 社会保险 · 职业伤害保障 / 退休一件事 =====
  { path: '/occupational-insured-query', title: '职业伤害保障参保信息查询', mode: 'query' },
  { path: '/occupational-confirm-query', title: '职业伤害确认信息查询', mode: 'query' },

  // ===== 人才人事 =====
  { path: '/archive-out', title: '档案转出', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '转入机构', placeholder: '请输入接收档案的单位/机构全称' }, { label: '转入地', placeholder: '如：苏州市姑苏区' }
  ], success: '档案转出申请已提交' },
  { path: '/archive-proof', title: '依据档案记载出具相关证明', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '证明事项', placeholder: '如：工龄证明、工作经历证明' }
  ], success: '证明开具申请已提交，请于3个工作日后领取' },
  { path: '/archive-in', title: '档案接收', mode: 'form', fields: [
    { label: '姓名' }, { label: '证件号码', maxlength: 18 }, { label: '原存档单位', placeholder: '请输入原档案保管单位全称' }
  ], success: '档案接收申请已提交' },
  { path: '/archive-query', title: '流动人员人事档案查询', mode: 'query', rows: [
    { '档案编号': 'NJ-DA-20230118', '存档机构': '南京市人才服务中心', '存档日期': '2023-01-18', '存档状态': '在库' }
  ] },
  { path: '/agent-query', title: '代理单位查询', mode: 'query', fields: [
    { label: '单位名称', placeholder: '请输入单位全称或关键字' }
  ] },
  { path: '/abroad-cert-query', title: '出国劳务人员换证查询', mode: 'query' },
  { path: '/ability-cert-query', title: '专项职业能力证书查询', mode: 'query' },
  { path: '/grade-cert-query', title: '职业技能等级认定证书查询', mode: 'query', rows: [
    { '证书编号': 'JS-DJ-2024-036721', '职业（工种）': '电工', '技能等级': '四级/中级工', '发证日期': '2024-06-12' }
  ] },
  { path: '/org-query', title: '培训、评价机构信息查询', mode: 'query', fields: [
    { label: '机构名称', placeholder: '请输入机构名称关键字' }, { label: '所在市县', placeholder: '如：南京市' }
  ], rows: [
    { '机构名称': '南京市职业技术培训中心', '机构类型': '培训机构', '所在区': '玄武区' },
    { '机构名称': '江苏省技能评价服务中心', '机构类型': '评价机构', '所在区': '鼓楼区' }
  ] },

  // ===== 劳动关系 =====
  { path: '/labor-complaint', title: '劳动保障监察投诉登记、调查、处理', mode: 'form', fields: [
    { label: '投诉人姓名' }, { label: '身份证号码', maxlength: 18 }, { label: '被投诉单位', placeholder: '请输入用人单位全称' }, { label: '投诉事项', type: 'textarea', placeholder: '请简述被投诉的违法行为及诉求，如：拖欠2026年6-8月工资' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '投诉已登记，我们将依法调查处理并及时反馈' },
  { path: '/labor-report', title: '劳动保障监察举报登记、调查、处理', mode: 'form', fields: [
    { label: '举报人姓名' }, { label: '被举报单位', placeholder: '请输入用人单位全称' }, { label: '举报事项', type: 'textarea', placeholder: '请简述被举报的违法行为线索' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '举报已登记，我们将依法核实处理' },
  { path: '/labor-case-query', title: '劳动保障监察案件查询', mode: 'query', rows: [
    { '案件编号': 'LC2026-0331', '案件类型': '拖欠工资', '立案日期': '2026-08-11', '办理状态': '处理中' },
    { '案件编号': 'LC2026-0217', '案件类型': '未签订劳动合同', '立案日期': '2026-05-09', '办理状态': '已办结' }
  ] },
  { path: '/wage-clue-report', title: '欠薪线索反映', mode: 'form', fields: [
    { label: '项目名称', placeholder: '请输入工程项目全称' }, { label: '所在市县', placeholder: '如：南京市江北新区' }, { label: '拖欠金额（元）', type: 'number' }, { label: '欠薪起始时间', placeholder: '如：2026-05' }, { label: '联系电话', type: 'tel', maxlength: 11 }
  ], success: '线索已提交，人社部门将尽快核实处理' },
  { path: '/migrant-attendance-query', title: '农民工考勤查询', mode: 'query', fields: [
    { label: '项目名称', placeholder: '请输入工程项目名称' }, { label: '考勤月份', placeholder: '如：2026-09' }
  ], rows: [
    { '考勤月份': '2026-09', '出勤天数': '26天', '打卡方式': '实名制闸机', '记录状态': '完整' },
    { '考勤月份': '2026-08', '出勤天数': '27天', '打卡方式': '实名制闸机', '记录状态': '完整' }
  ] },
  { path: '/migrant-wage-calc', title: '农民工工资核算确认', mode: 'form', fields: [
    { label: '项目名称' }, { label: '核算月份', placeholder: '如：2026-09' }, { label: '确认金额（元）', type: 'number' }
  ], success: '工资核算已确认' },
  { path: '/leave-settle-confirm', title: '离场结算清算确认', mode: 'form', fields: [
    { label: '项目名称' }, { label: '离场日期', placeholder: '如：2026-09-30' }, { label: '结算金额（元）', type: 'number' }
  ], success: '离场结算清算已确认' },
  { path: '/wage-appeal', title: '工资异议申诉', mode: 'form', fields: [
    { label: '项目名称' }, { label: '异议月份', placeholder: '如：2026-08' }, { label: '申诉说明', type: 'textarea', placeholder: '请简述工资异议的具体内容' }
  ], success: '申诉已提交，请等待核处反馈' },
  { path: '/project-history-query', title: '项目履历查询', mode: 'query', rows: [
    { '项目名称': '江北新区人才公寓项目', '参建单位': '江苏超芯星半导体有限公司', '工种': '电工', '进场时间': '2024-03-01', '离场时间': '—' }
  ] },
  { path: '/complaint-query', title: '个人投诉、举报查询', mode: 'query', rows: [
    { '登记编号': 'TS2026-0905', '类型': '投诉', '登记日期': '2026-09-05', '办理状态': '已办结' }
  ] },
  { path: '/wage-handle', title: '工资异议核处', mode: 'form', fields: [
    { label: '项目名称' }, { label: '异议月份', placeholder: '如：2026-08' }, { label: '核处说明', type: 'textarea', placeholder: '请填写异议核处情况说明' }
  ], success: '核处申请已提交' },
  { path: '/wage-clue-query', title: '个人欠薪线索查询', mode: 'query', rows: [
    { '线索编号': 'XS2026-0712', '反映事项': '拖欠工资', '提交日期': '2026-07-12', '处理状态': '已办结' }
  ] },
  { path: '/agreement-sign', title: '农民工用工协议签名', mode: 'form', fields: [
    { label: '项目名称' }, { label: '协议编号', placeholder: '请输入待签署协议编号' }
  ], success: '已完成电子签名确认' },
  { path: '/agreement-query', title: '农民工用工协议查询', mode: 'query', rows: [
    { '协议编号': 'XY2026-0031', '项目名称': '人才公寓项目', '签署日期': '2026-03-05', '签署状态': '已签署' }
  ] },

  // ===== 社会保障卡 =====
  { path: '/card-enable', title: '社会保障卡启用', mode: 'form', fields: [
    { label: '社会保障号码', maxlength: 18 }, { label: '卡号', required: false, placeholder: '选填' }
  ], success: '社会保障卡已启用' },
  { path: '/card-loss', title: '社会保障卡正式挂失与解挂', mode: 'form', fields: [
    { label: '社会保障号码', maxlength: 18 }, { label: '办理类型', placeholder: '挂失或解挂' }
  ], success: '办理成功' },
  { path: '/card-replace', title: '社会保障卡补卡', mode: 'form', fields: [
    { label: '社会保障号码', maxlength: 18 }, { label: '补卡原因', placeholder: '如：卡片损坏、遗失' }, { label: '领卡网点', placeholder: '如：江北新区社保卡服务网点' }
  ], success: '补卡申请已受理，制卡完成后短信通知' },
  { path: '/card-progress-query', title: '制卡进度查询', mode: 'query', rows: [
    { '制卡状态': '已制卡待领用', '服务网点': '江北新区社保卡服务网点', '更新日期': '2026-09-30' }
  ] },
  { path: '/card-cancel', title: '社会保障卡注销', mode: 'form', fields: [
    { label: '社会保障号码', maxlength: 18 }, { label: '注销原因', placeholder: '如：转出省外、死亡注销' }
  ], success: '注销申请已受理' }
]



// WEBPACK FOOTER //
// ./src/data/svcPages.js